module.exports = __webpack_public_path__ + "static/media/icon-toggle-on.ef8f0cc8.svg";